import React from 'react';
import './HomePage.css';

const HomePage: React.FC = () => {
    return (
        <div className="homepage">
            <header className="header">
                <nav className="nav">
                    <h1 className="logo">DevPortfolio</h1>
                    <ul className="nav-links">
                        <li><a href="#about">About</a></li>
                        <li><a href="#projects">Projects</a></li>
                        <li><a href="#skills">Skills</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </nav>
            </header>

            <main className="main">
                <section className="hero">
                    <div className="hero-content">
                        <h1 className="hero-title">
                            Hi, I'm <span className="highlight">JO KIL</span>
                        </h1>
                        <h2 className="hero-subtitle">Full Stack Developer</h2>
                        <p className="hero-description">
                            I create modern, responsive web applications using cutting-edge technologies.
                            Passionate about clean code, user experience, and innovative solutions.
                        </p>
                        <div className="hero-buttons">
                            <a href="#projects" className="btn btn-primary">View My Work</a>
                            <a href="#contact" className="btn btn-secondary">Get In Touch</a>
                        </div>
                    </div>
                </section>

                <section id="about" className="about-section">
                    <div className="container">
                        <h2 className="section-title">About Me</h2>
                        <div className="about-content">
                            <div className="about-text">
                                <p>
                                    I'm a passionate full-stack developer with over 5 years of experience
                                    building web applications. I specialize in React, Node.js, and modern
                                    JavaScript frameworks.
                                </p>
                                <p>
                                    I love solving complex problems and turning ideas into beautiful,
                                    functional applications. When I'm not coding, you can find me
                                    exploring new technologies or contributing to open-source projects.
                                </p>
                            </div>
                            <div className="about-stats">
                                <div className="stat">
                                    <h3>50+</h3>
                                    <p>Projects Completed</p>
                                </div>
                                <div className="stat">
                                    <h3>5+</h3>
                                    <p>Years Experience</p>
                                </div>
                                <div className="stat">
                                    <h3>100%</h3>
                                    <p>Client Satisfaction</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="skills" className="skills-section">
                    <div className="container">
                        <h2 className="section-title">Skills & Technologies</h2>
                        <div className="skills-grid">
                            <div className="skill-card">
                                <h3>Frontend</h3>
                                <ul>
                                    <li>React</li>
                                    <li>TypeScript</li>
                                    <li>Next.js</li>
                                    <li>Vue.js</li>
                                    <li>CSS3/SASS</li>
                                </ul>
                            </div>
                            <div className="skill-card">
                                <h3>Backend</h3>
                                <ul>
                                    <li>Node.js</li>
                                    <li>Express</li>
                                    <li>Python</li>
                                    <li>PostgreSQL</li>
                                    <li>MongoDB</li>
                                </ul>
                            </div>
                            <div className="skill-card">
                                <h3>Tools & Others</h3>
                                <ul>
                                    <li>Git/GitHub</li>
                                    <li>Docker</li>
                                    <li>AWS</li>
                                    <li>Jest</li>
                                    <li>Figma</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="projects" className="projects-section">
                    <div className="container">
                        <h2 className="section-title">Featured Projects</h2>
                        <div className="projects-grid">
                            <div className="project-card">
                                <h3>E-Commerce Platform</h3>
                                <p>A full-stack e-commerce solution built with React, Node.js, and PostgreSQL.</p>
                                <div className="project-tech">
                                    <span>React</span>
                                    <span>Node.js</span>
                                    <span>PostgreSQL</span>
                                </div>
                            </div>
                            <div className="project-card">
                                <h3>Task Management App</h3>
                                <p>A collaborative task management application with real-time updates.</p>
                                <div className="project-tech">
                                    <span>Vue.js</span>
                                    <span>Socket.io</span>
                                    <span>MongoDB</span>
                                </div>
                            </div>
                            <div className="project-card">
                                <h3>Analytics Dashboard</h3>
                                <p>A data visualization dashboard for business intelligence.</p>
                                <div className="project-tech">
                                    <span>React</span>
                                    <span>D3.js</span>
                                    <span>Python</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contact" className="contact-section">
                    <div className="container">
                        <h2 className="section-title">Let's Work Together</h2>
                        <div className="contact-content">
                            <p>
                                I'm always interested in new opportunities and exciting projects.
                                Let's discuss how we can bring your ideas to life!
                            </p>
                            <div className="contact-info">
                                <a href="" className="contact-link">
                                    g95089501@gmail.com
                                </a>
                                <a href="https://kr.linkedin.com/in/solinkil" className="contact-link">
                                    LinkedIn
                                </a>
                                <a href="https://github.com/joeKil" className="contact-link">
                                    GitHub
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <div className="container">
                    <p>&copy; 2025 Jo Kil. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default HomePage; 